// extracted by mini-css-extract-plugin
module.exports = {"news":"LandingNews_news__J8_I2","inner":"LandingNews_inner__UQN0f","grid":"LandingNews_grid__58EK1"};